<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"width: 95%;"' class="mx-auto my-5 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 col-lg-8" >
                <template #default>   <m-content-slider-1 v-bind='{...{"contentType":"page","contentCategory":["header-slider-en"]},...{}}' :style='"min-height: auto;\nmax-height: 650px;\nborder-radius: 6px;"' class="w-100" ></m-content-slider-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-4 p-0 pr-lg-3 header-card-section" >
                <template #default>   <m-content-archive-1 v-bind='{...{"contentCategory":["hero-items-en"],"contentType":"page"},...{}}' :style='""' class="" ></m-content-archive-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-categories-309 v-bind='{...{},...{}}' :style='""' class="container" ></m-categories-309><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-content-archive-2 v-bind='{...{"contentCategory":["banners-en"],"contentType":"page","itemClass":"col-lg-6"},...{}}' :style='""' class="row" ></m-content-archive-2></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"background:#a4ce58;\nbackground-image: url(\"https:\/\/api.roshdfarms.ir\/storage\/assets\/pattern.png\");\n"' class="py-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="mb-5 container" >
                <template #default>   <m-product-slider-1 v-bind='{...{"title":"Special Sale","productCategories":["special-offer-en"],"productBrands":null,"waitForCategory":false,"waitForBrand":false,"categoryColumn":"slug","brandColumn":"slug"},...{}}' :style='""' class="" ></m-product-slider-1></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-fantasy-content-300 v-bind='{...{"contentCategory":["slide-show-en"],"contentType":"post"},...{}}' :style='""' class="" ></m-fantasy-content-300></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mContentSlider1 from '@moeinmdn/miw-alpha-components/src/package/Content/Slider/ContentSlider1'; import mContentArchive1 from '@moeinmdn/miw-alpha-components/src/package/Content/Archive/ContentArchive1'; import mCategories309 from '@moeinmdn/miw-alpha-components/src/package/Category/Categories/Categories309'; import mContentArchive2 from '@moeinmdn/miw-alpha-components/src/package/Content/Archive/ContentArchive2'; import mProductSlider1 from '@moeinmdn/miw-alpha-components/src/package/Product/ProductSlider/ProductSlider1'; import mFantasyContent300 from '@moeinmdn/miw-alpha-components/src/package/Content/Fantasy/FantasyContent300';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mContentSlider1,mContentArchive1,mCategories309,mContentArchive2,mProductSlider1,mFantasyContent300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
